import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TestingView from '../views/TestingView.vue'
import LoginView from '../views/LoginView.vue'
import ProfileView from '../views/ProfileView.vue'
import Instances from '../views/instances/Instances.vue'
import InstanceTimeline from '../views/instances/InstanceTimeline.vue'
import BroadcastQueue from '../views/broadcast/BroadcastQueue.vue'
import Chat from '../views/chat/Chat.vue'
import Contact from '../views/contact/Contact.vue'
import Doc from '../views/doc/Doc.vue'
import WarmingScripts from '../views/warming/Scripts.vue'
import WarmingRooms from '../views/warming/Rooms.vue'
import WarmingTemplates from '../views/warming/Templates.vue'
import Checker from '../views/checker/Checker.vue'
import NotFound from '../views/NotFound.vue'
import SystemIdentity from '../views/settings/SystemIdentity.vue'
import WorkerConfig from '../views/worker/WorkerConfig.vue'
import axios from 'axios'
import NProgress from 'nprogress';

const routes = [
  { path: '/login', name: 'login', component: LoginView },
  { path: '/register', redirect: '/login' },
  { path: '/', name: 'home', component: HomeView, meta: { requiresAuth: true } },
  { path: '/profile', name: 'profile', component: ProfileView, meta: { requiresAuth: true } },
  { path: '/testing', name: 'testing', component: TestingView, meta: { requiresAuth: true } },
  { path: '/instances', name: 'instances', component: Instances, meta: { requiresAuth: true } },
  { path: '/timeline', name: 'timeline', component: InstanceTimeline, meta: { requiresAuth: true } },
  { path: '/broadcast', name: 'broadcast', component: BroadcastQueue, meta: { requiresAuth: true } },
  { path: '/chat', name: 'chat', component: Chat, meta: { requiresAuth: true } },
  { path: '/contact', name: 'contact', component: Contact, meta: { requiresAuth: true } },
  { path: '/checker', name: 'checker', component: Checker, meta: { requiresAuth: true } },
  { path: '/settings/identity', name: 'system-identity', component: SystemIdentity, meta: { requiresAuth: true } },
  { path: '/doc', name: 'doc', component: Doc, meta: { requiresAuth: true } },
  { path: '/warming/scripts', name: 'warming-scripts', component: WarmingScripts, meta: { requiresAuth: true } },
  { path: '/warming/rooms', name: 'warming-rooms', component: WarmingRooms, meta: { requiresAuth: true } },
  { path: '/warming/templates', name: 'warming-templates', component: WarmingTemplates, meta: { requiresAuth: true } },
  { path: '/worker-config', name: 'worker-config', component: WorkerConfig, meta: { requiresAuth: true } },
  // Catch-all 404 route (must be last)
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const beUrl = process.env.VUE_APP_BE_APP_BASE_URL

// Function to validate token
async function validateToken() {
  const accessToken = localStorage.getItem('access_token')
  if (!accessToken) return false

  try {
    // Use /api/me endpoint to validate token
    await axios.get(`${beUrl}/api/me`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    })
    return true
  } catch (error) {
    // Token invalid/expired
    // Don't clear here, let axios interceptor handle it
    return false
  }
}

// Router guard with token validation
router.beforeEach(async (to, from, next) => {
  const accessToken = localStorage.getItem('access_token')

  if (to.meta.requiresAuth) {
    if (!accessToken) {
      // No token, redirect to login
      next({ name: 'login' })
    } else {
      // Has token, validate it
      const isValid = await validateToken()
      if (isValid) {
        next()
      } else {
        next({ name: 'login' })
      }
    }
  }
  else if (to.path === '/login' && accessToken) {
    // Validate token before redirecting to home
    const isValid = await validateToken()
    if (isValid) {
      next({ name: 'home' })
    } else {
      next()
    }
  }
  else {
    next()
  }
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
